
import { mapState, mapGetters, mapActions } from 'vuex'
import { getPrice } from '~/utils/currency'

export default {
  data () {
    return {
      currencyChange: {},
      search: false,
      car: false,
      searchString: ''
    }
  },
  computed: {
    ...mapState({
      searchItems: state => state.products.search_products,
      loggedIn: state => state.auth.loggedIn
    }),
    ...mapGetters({
      cartOrder: 'orders/getOrder',
      curr: 'products/getCurrency'
    }),
    availableLocales () {
      return this.$i18n.locales
    }
  },
  methods: {
    ...mapActions({
      resetCart: 'orders/resetCart'
    }),
    getImgUrl (path) {
      return require('@/assets/images/' + path)
    },
    getProductImgUrl (product) {
      if (product && product.data && product.data.media && product.data.media.data && product.data.media.data.length > 0) {
        for (let i = 0; i < product.data.media.data.length; i++) {
          const media = product.data.media.data[i]
          if (media.mime_type.includes('image')) {
            if (media.urls.medium) {
              return media.urls.medium
            } else if (media.urls.original) {
              return media.urls.original
            }
          }
        }
      }

      return require('@/assets/images/default-product.jpg')
    },
    openSearch () {
      this.search = true
    },
    closeSearch () {
      this.search = false
    },
    openCar () {
      this.car = true
    },
    closeCar () {
      this.car = false
    },
    searchProduct () {
      this.$store.dispatch('products/searchProducts', this.searchString)
    },
    removeCartItem (item) {
      this.$store.dispatch('orders/removeCartItem', { item })
    },
    updateCurrency (currency, currSymbol) {
      this.currencyChange = { curr: currency, symbol: currSymbol }
      this.$store.dispatch('products/changeCurrency', this.currencyChange)
    },
    logout () {
      this.resetCart()
      this.$auth.logout()
    },
    getItemPrice (item) {
      return getPrice(item.price, item.discount, true, Number(this.cartOrder.vat_rate), true)
    }
  }
}
